webpackJsonp([27274157999680],{

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(76);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var className = props.className,
	      elementRef = props.elementRef,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      onBlur = props.onBlur,
	      onReady = props.onReady,
	      options = _objectWithoutProperties(props, ['className', 'elementRef', 'onChange', 'onFocus', 'onBlur', 'onReady']);
	
	  return options;
	};
	
	var Element = function Element(type) {
	  var _class, _temp;
	
	  var hocOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));
	
	      _this.handleRef = function (ref) {
	        _this._ref = ref;
	      };
	
	      var options = _extractOptions(_this.props);
	      _this._element = _this.context.elements.create(type, options);
	      _this._setupEventListeners();
	      _this._options = options;
	      return _this;
	    }
	
	    _createClass(_class, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this._element.mount(this._ref);
	        if (hocOptions.sourceType) {
	          this.context.registerElement(hocOptions.sourceType, this._element);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var options = _extractOptions(nextProps);
	        if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
	          this._options = options;
	          this._element.update(options);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this._element.destroy();
	        this.context.unregisterElement(this._element);
	      }
	    }, {
	      key: '_setupEventListeners',
	      value: function _setupEventListeners() {
	        var _this2 = this;
	
	        this._element.on('ready', function () {
	          _this2.props.elementRef(_this2._element);
	          _this2.props.onReady();
	        });
	
	        this._element.on('change', function (change) {
	          _this2.props.onChange(change);
	        });
	
	        this._element.on('blur', function () {
	          var _props;
	
	          return (_props = _this2.props).onBlur.apply(_props, arguments);
	        });
	        this._element.on('focus', function () {
	          var _props2;
	
	          return (_props2 = _this2.props).onFocus.apply(_props2, arguments);
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement('div', { className: this.props.className, ref: this.handleRef });
	      }
	    }]);
	
	    return _class;
	  }(_react2.default.Component), _class.propTypes = {
	    className: _propTypes2.default.string,
	    elementRef: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onReady: _propTypes2.default.func
	  }, _class.defaultProps = {
	    className: '',
	    elementRef: noop,
	    onChange: noop,
	    onBlur: noop,
	    onFocus: noop,
	    onReady: noop
	  }, _class.contextTypes = {
	    elements: _propTypes2.default.object.isRequired,
	    registerElement: _propTypes2.default.func.isRequired,
	    unregisterElement: _propTypes2.default.func.isRequired
	  }, _temp;
	};
	
	exports.default = Element;

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Elements = function (_React$Component) {
	  _inherits(Elements, _React$Component);
	
	  function Elements(props, context) {
	    _classCallCheck(this, Elements);
	
	    var _this = _possibleConstructorReturn(this, (Elements.__proto__ || Object.getPrototypeOf(Elements)).call(this, props, context));
	
	    _this.handleRegisterElement = function (type, element) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: [].concat(_toConsumableArray(prevState.registeredElements), [{ type: type, element: element }])
	        };
	      });
	    };
	
	    _this.handleUnregisterElement = function (el) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: prevState.registeredElements.filter(function (_ref) {
	            var element = _ref.element;
	            return element !== el;
	          })
	        };
	      });
	    };
	
	    var _this$props = _this.props,
	        children = _this$props.children,
	        options = _objectWithoutProperties(_this$props, ['children']);
	
	    _this._elements = _this.context.stripe.elements(options);
	
	    _this.state = {
	      registeredElements: []
	    };
	    return _this;
	  }
	
	  _createClass(Elements, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        elements: this._elements,
	        registerElement: this.handleRegisterElement,
	        unregisterElement: this.handleUnregisterElement,
	        registeredElements: this.state.registeredElements
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.Children.only(this.props.children);
	    }
	  }]);
	
	  return Elements;
	}(_react2.default.Component);
	
	Elements.childContextTypes = {
	  elements: _propTypes2.default.object.isRequired,
	  registerElement: _propTypes2.default.func.isRequired,
	  unregisterElement: _propTypes2.default.func.isRequired,
	  registeredElements: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    type: _propTypes2.default.string.isRequired,
	    element: _propTypes2.default.object.isRequired
	  })).isRequired
	};
	Elements.contextTypes = {
	  stripe: _propTypes2.default.object.isRequired
	};
	Elements.defaultProps = {
	  children: null
	};
	exports.default = Elements;

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(76);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var className = props.className,
	      elementRef = props.elementRef,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onReady = props.onReady,
	      paymentRequest = props.paymentRequest,
	      options = _objectWithoutProperties(props, ['className', 'elementRef', 'onBlur', 'onClick', 'onFocus', 'onReady', 'paymentRequest']);
	
	  return options;
	};
	
	var PaymentRequestButtonElement = function (_React$Component) {
	  _inherits(PaymentRequestButtonElement, _React$Component);
	
	  function PaymentRequestButtonElement(props, context) {
	    _classCallCheck(this, PaymentRequestButtonElement);
	
	    var _this = _possibleConstructorReturn(this, (PaymentRequestButtonElement.__proto__ || Object.getPrototypeOf(PaymentRequestButtonElement)).call(this, props, context));
	
	    _this.handleRef = function (ref) {
	      _this._ref = ref;
	    };
	
	    var options = _extractOptions(props);
	    _this._element = _this.context.elements.create('paymentRequestButton', _extends({
	      paymentRequest: props.paymentRequest
	    }, options));
	    _this._options = options;
	    _this._element.on('ready', function () {
	      _this.props.elementRef(_this._element);
	      _this.props.onReady();
	    });
	    _this._element.on('focus', function () {
	      var _this$props;
	
	      return (_this$props = _this.props).onFocus.apply(_this$props, arguments);
	    });
	    _this._element.on('click', function () {
	      var _this$props2;
	
	      return (_this$props2 = _this.props).onClick.apply(_this$props2, arguments);
	    });
	    _this._element.on('blur', function () {
	      var _this$props3;
	
	      return (_this$props3 = _this.props).onBlur.apply(_this$props3, arguments);
	    });
	    return _this;
	  }
	
	  _createClass(PaymentRequestButtonElement, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._element.mount(this._ref);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.paymentRequest !== nextProps.paymentRequest) {
	        console.warn('Unsupported prop change: paymentRequest is not a customizable property.');
	      }
	      var options = _extractOptions(nextProps);
	      if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
	        this._options = options;
	        this._element.update(options);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._element.destroy();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { className: this.props.className, ref: this.handleRef });
	    }
	  }]);
	
	  return PaymentRequestButtonElement;
	}(_react2.default.Component);
	
	PaymentRequestButtonElement.propTypes = {
	  className: _propTypes2.default.string,
	  elementRef: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onReady: _propTypes2.default.func,
	  paymentRequest: _propTypes2.default.shape({
	    canMakePayment: _propTypes2.default.func.isRequired,
	    on: _propTypes2.default.func.isRequired,
	    show: _propTypes2.default.func.isRequired
	  }).isRequired
	};
	PaymentRequestButtonElement.defaultProps = {
	  className: '',
	  elementRef: noop,
	  onBlur: noop,
	  onClick: noop,
	  onFocus: noop,
	  onReady: noop
	};
	PaymentRequestButtonElement.contextTypes = {
	  elements: _propTypes2.default.object.isRequired,
	  registerElement: _propTypes2.default.func.isRequired,
	  unregisterElement: _propTypes2.default.func.isRequired
	};
	exports.default = PaymentRequestButtonElement;

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Provider = function (_React$Component) {
	  _inherits(Provider, _React$Component);
	
	  function Provider(props) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).call(this, props));
	
	    if (!window.Stripe) {
	      throw new Error('Please load Stripe.js (https://js.stripe.com/v3/) on this page to use react-stripe-elements.');
	    }
	
	    var _this$props = _this.props,
	        apiKey = _this$props.apiKey,
	        children = _this$props.children,
	        options = _objectWithoutProperties(_this$props, ['apiKey', 'children']);
	
	    /**
	     * Note that this is not meant to be a generic memoization solution.
	     * This is specifically a solution for `StripeProvider`s being initialized
	     * and destroyed regularly (with the same set of props) when users only
	     * use `StripeProvider` for the subtree that contains their checkout form.
	     */
	
	
	    window.Stripe.__cachedInstances = window.Stripe.__cachedInstances || {};
	    var cacheKey = 'key=' + apiKey + ' options=' + JSON.stringify(options);
	    _this._stripe = window.Stripe.__cachedInstances[cacheKey] || window.Stripe(apiKey, options);
	    window.Stripe.__cachedInstances[cacheKey] = _this._stripe;
	
	    _this._didWarn = false;
	    return _this;
	  }
	  // Even though we're using flow, also use PropTypes so we can take advantage of developer warnings.
	
	
	  _createClass(Provider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        stripe: this._stripe
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this._didWarn && this.props.apiKey !== nextProps.apiKey && window.console && window.console.error) {
	        this._didWarn = true;
	        // eslint-disable-next-line no-console
	        console.error('StripeProvider does not support changing the apiKey parameter.');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.Children.only(this.props.children);
	    }
	  }]);
	
	  return Provider;
	}(_react2.default.Component);
	
	Provider.propTypes = {
	  apiKey: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.node
	};
	Provider.childContextTypes = {
	  stripe: _propTypes2.default.object.isRequired
	};
	Provider.defaultProps = {
	  children: null
	};
	exports.default = Provider;

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// react-redux does a bunch of stuff with pure components / checking if it needs to re-render.
	// not sure if we need to do the same.
	var inject = function inject(WrappedComponent) {
	  var _class, _temp;
	
	  var componentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _componentOptions$wit = componentOptions.withRef,
	      withRef = _componentOptions$wit === undefined ? false : _componentOptions$wit;
	
	
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      if (!context || !context.registeredElements) {
	        throw new Error('It looks like you are trying to inject Stripe context outside of an Elements context.\nPlease be sure the component that calls createSource or createToken is within an <Elements> component.');
	      }
	
	      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));
	
	      _this.requireElement = function (specifiedType) {
	        var element = _this.findElement(specifiedType);
	        if (element) {
	          return element;
	        } else {
	          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
	        }
	      };
	
	      _this.findElement = function (specifiedType) {
	        var allElements = _this.context.registeredElements || [];
	        var matchingElements = specifiedType === 'auto' ? allElements : allElements.filter(function (_ref) {
	          var type = _ref.type;
	          return type === specifiedType;
	        });
	
	        if (matchingElements.length === 1) {
	          return matchingElements[0].element;
	        } else if (matchingElements.length > 1) {
	          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
	        } else {
	          return null;
	        }
	      };
	
	      _this.wrappedCreateToken = function () {
	        var typeOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (typeOrOptions && (typeof typeOrOptions === 'undefined' ? 'undefined' : _typeof(typeOrOptions)) === 'object') {
	          var type = typeOrOptions.type,
	              rest = _objectWithoutProperties(typeOrOptions, ['type']);
	
	          var specifiedType = typeof type === 'string' ? type : 'auto';
	          var element = _this.requireElement(specifiedType);
	          return _this.context.stripe.createToken(element, rest);
	        } else if (typeof typeOrOptions === 'string') {
	          return _this.context.stripe.createToken(typeOrOptions, options);
	        } else {
	          throw new Error('Invalid options passed to createToken. Expected an object, got ' + (typeof typeOrOptions === 'undefined' ? 'undefined' : _typeof(typeOrOptions)) + '.');
	        }
	      };
	
	      _this.wrappedCreateSource = function () {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	          var type = options.type,
	              rest = _objectWithoutProperties(options, ['type']); // eslint-disable-line no-unused-vars
	
	
	          var specifiedType = typeof type === 'string' ? type : 'auto';
	          var element = _this.findElement(specifiedType);
	          if (element) {
	            return _this.context.stripe.createSource(element, rest);
	          } else if (specifiedType !== 'auto') {
	            return _this.context.stripe.createSource(options);
	          } else {
	            throw new Error('You did not specify the type of Source to create.\n          We also could not find any Elements in the current context.');
	          }
	        } else {
	          throw new Error('Invalid options passed to createSource. Expected an object, got ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + '.');
	        }
	      };
	
	      return _this;
	    }
	
	    _createClass(_class, [{
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        if (!withRef) {
	          throw new Error('To access the wrapped instance, the `{withRef: true}` option must be set when calling `injectStripe()`');
	        }
	        return this.wrappedInstance;
	      }
	    }, {
	      key: 'stripeProps',
	      value: function stripeProps() {
	        return _extends({}, this.context.stripe, {
	          // These are the only functions that take elements.
	          createToken: this.wrappedCreateToken,
	          createSource: this.wrappedCreateSource
	        });
	      }
	      // Require that exactly one Element is found.
	
	      // Finds the element by the specified type. Throws if multiple Elements match.
	
	
	      // createToken has a bit of an unusual method signature for legacy reasons
	      // -- we're allowed to pass in the token type OR the element as the first parameter,
	      // so we need to check if we're passing in a string as the first parameter and
	      // just pass through the options if that's the case.
	
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
	          stripe: this.stripeProps(),
	          ref: withRef ? function (c) {
	            _this2.wrappedInstance = c;
	          } : null
	        }));
	      }
	    }]);
	
	    return _class;
	  }(_react2.default.Component), _class.contextTypes = {
	    stripe: _propTypes2.default.object.isRequired,
	    registeredElements: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      element: _propTypes2.default.object.isRequired,
	      type: _propTypes2.default.string.isRequired
	    }))
	  }, _class.displayName = 'InjectStripe(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp;
	};
	
	exports.default = inject;

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaymentRequestButtonElement = exports.PostalCodeElement = exports.CardCVCElement = exports.CardExpiryElement = exports.CardNumberElement = exports.CardElement = exports.Elements = exports.injectStripe = exports.StripeProvider = undefined;
	
	var _Provider = __webpack_require__(171);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _inject = __webpack_require__(172);
	
	var _inject2 = _interopRequireDefault(_inject);
	
	var _Elements = __webpack_require__(169);
	
	var _Elements2 = _interopRequireDefault(_Elements);
	
	var _Element = __webpack_require__(168);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	var _PaymentRequestButtonElement = __webpack_require__(170);
	
	var _PaymentRequestButtonElement2 = _interopRequireDefault(_PaymentRequestButtonElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardElement = (0, _Element2.default)('card', { sourceType: 'card' });
	
	var CardNumberElement = (0, _Element2.default)('cardNumber', { sourceType: 'card' });
	var CardExpiryElement = (0, _Element2.default)('cardExpiry');
	var CardCVCElement = (0, _Element2.default)('cardCvc');
	var PostalCodeElement = (0, _Element2.default)('postalCode');
	
	exports.StripeProvider = _Provider2.default;
	exports.injectStripe = _inject2.default;
	exports.Elements = _Elements2.default;
	exports.CardElement = CardElement;
	exports.CardNumberElement = CardNumberElement;
	exports.CardExpiryElement = CardExpiryElement;
	exports.CardCVCElement = CardCVCElement;
	exports.PostalCodeElement = PostalCodeElement;
	exports.PaymentRequestButtonElement = _PaymentRequestButtonElement2.default;

/***/ }),

/***/ 76:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var shallowEqual = function shallowEqual(a, b) {
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  return keysA.length === keysB.length && keysA.every(function (key) {
	    return b.hasOwnProperty(key) && b[key] === a[key];
	  });
	};
	
	exports.default = shallowEqual;

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__(38);
	
	var _CheckoutForm = __webpack_require__(394);
	
	var _CheckoutForm2 = _interopRequireDefault(_CheckoutForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Checkout = function (_React$Component) {
	    _inherits(Checkout, _React$Component);
	
	    function Checkout() {
	        _classCallCheck(this, Checkout);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Checkout.prototype.render = function render() {
	        return _react2.default.createElement(
	            _reactStripeElements.Elements,
	            null,
	            _react2.default.createElement(_CheckoutForm2.default, null)
	        );
	    };
	
	    return Checkout;
	}(_react2.default.Component);
	
	exports.default = Checkout;
	module.exports = exports['default'];

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__(38);
	
	var _reactstrap = __webpack_require__(10);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _spinner = __webpack_require__(104);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var serverHost = '' + ("https://product.datasert.com");
	var purchaseUrl = serverHost + "/api/v2.0/license/purchase";
	var edition_essential = 'essential';
	var edition_professional = 'professional';
	var edition_enterprise = 'enterprise';
	
	/**
	 * Returns the edition from the url assuming it is the only parameter. If anything goes wrong,
	 * return undefiend. This is very primitive but does the job for our purpose.
	 */
	var getEdition = function getEdition() {
	    var edition = edition_essential;
	    try {
	        if (document) {
	            var parser = document.createElement('a');
	            parser.href = location.href;
	            edition = parser.search;
	            if (edition) {
	                edition = edition.substring(1).split(',');
	                edition = edition[0].split('=')[1];
	            }
	        }
	
	        if (edition !== edition_essential && edition !== edition_professional && edition !== edition_enterprise) {
	            edition = edition_essential;
	        }
	    } catch (error) {
	        console.error(error);
	    }
	    return edition;
	};
	
	var getUnitPrice = function getUnitPrice(edition, quantity) {
	    var basePrice = 0;
	    var basePrice = 0;
	    if (edition === edition_essential) {
	        basePrice = 129;
	    } else if (edition === edition_professional) {
	        basePrice = 499;
	    } else if (edition === edition_enterprise) {
	        basePrice = 999;
	    } else {
	        //else we will assume essential
	        basePrice = 129;
	    }
	
	    var discountMultiplier = 1;
	    if (quantity == 1) {
	        discountMultiplier = 1;
	    } else if (quantity > 1 && quantity <= 4) {
	        discountMultiplier = 0.9;
	    } else if (quantity > 4 && quantity <= 9) {
	        discountMultiplier = 0.85;
	    } else if (quantity > 10 && quantity <= 19) {
	        discountMultiplier = 0.8;
	    } else {
	        discountMultiplier = 0.75;
	    }
	
	    return Math.floor(basePrice * discountMultiplier);
	};
	
	var getTotalPrice = function getTotalPrice(edition, quantity) {
	    return getUnitPrice(edition, quantity) * quantity;
	};
	
	var getEditionName = function getEditionName(edition) {
	    if (edition === edition_essential) {
	        return 'Essential';
	    } else if (edition === edition_professional) {
	        return 'Professional';
	    } else if (edition === edition_enterprise) {
	        return 'Enterprise';
	    } else {
	        throw new Error('Unknown edition ' + edition);
	    }
	};
	
	var isBlank = function isBlank(value) {
	    if (!value) {
	        return true;
	    }
	
	    if (value === '') {
	        return true;
	    }
	
	    return false;
	};
	
	var readBody = function readBody(resp) {
	    return new Promise(function (resolve, reject) {
	        resp.text().then(function (body) {
	            var apiResp = {};
	            apiResp.url = resp.url;
	            apiResp.status_code = resp.status;
	
	            if (!isBlank(body)) {
	                apiResp.body = JSON.parse(body);
	            }
	
	            resolve(apiResp);
	        }).catch(reject);
	    });
	};
	
	var CheckoutForm = function (_React$Component) {
	    _inherits(CheckoutForm, _React$Component);
	
	    function CheckoutForm(props) {
	        _classCallCheck(this, CheckoutForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.handleSubmit = function (ev) {
	            // We don't want to let default form submission happen here, which would refresh the page.
	            ev.preventDefault();
	
	            var state = _this.state;
	            if (state.first_name === '') {
	                _this.setState(_extends(state, { contactError: true, contactErrorMessage: 'Please enter Contact First Name' }));
	                return;
	            }
	
	            if (state.last_name === '') {
	                _this.setState(_extends(state, { contactError: true, contactErrorMessage: 'Please enter Contact Last Name' }));
	                return;
	            }
	
	            if (state.email === '') {
	                _this.setState(_extends(state, { contactError: true, contactErrorMessage: 'Please enter Contact Email' }));
	                return;
	            }
	
	            if (state.phone === '') {
	                _this.setState(_extends(state, { contactError: true, contactErrorMessage: 'Please enter Contact Phone' }));
	                return;
	            }
	
	            if (state.first_name === '' || state.last_name === '' || state.email === '' || state.phone === '') {
	                _this.setState(_extends(state, { contactError: true, contactErrorMessage: 'Please enter Contact details' }));
	                return;
	            } else {
	                _this.setState(_extends(state, { contactError: false }));
	            }
	
	            if (state.card_name === '') {
	                _this.setState(_extends(state, { paymentError: true, paymentErrorMessage: 'Please enter card holder\'s name' }));
	                return;
	            } else {
	                _this.setState(_extends(state, { paymentError: false }));
	            }
	
	            if (state.paymentDetailsComplete === false) {
	                var msg = state.paymentDetailsMessage;
	                if (!msg || msg === '') {
	                    msg = 'Please enter Payment Card details';
	                }
	                _this.setState(_extends(state, { paymentError: true, paymentErrorMessage: msg }));
	                return;
	            } else {
	                _this.setState(_extends(state, { paymentError: false }));
	            }
	
	            _this.setState(_extends(state, { paymentProcessing: true }));
	
	            // Within the context of `Elements`, this call to createToken knows which Element to
	            // tokenize, since there's only one in this group.
	            _this.props.stripe.createToken({ name: state.card_name }).then(function (_ref) {
	                var token = _ref.token;
	
	                var req = {
	                    first_name: state.first_name,
	                    last_name: state.last_name,
	                    email: state.email,
	                    phone: state.phone,
	                    company: state.company,
	                    product: 'realforce',
	                    edition: state.edition,
	                    quantity: state.quantity,
	                    payment_details: JSON.stringify(token)
	                };
	
	                fetch(purchaseUrl, {
	                    method: 'POST',
	                    headers: { 'Content-Type': 'application/json' },
	                    body: JSON.stringify(req)
	                }).then(readBody).then(function (resp) {
	                    _this.setState(_extends(state, { paymentProcessing: false }));
	
	                    if (resp.status_code >= 300) {
	                        _this.setState(_extends(state, { processingError: true, processingErrorMessage: 'Processing of request failed.  ' + resp.body.message }));
	                    } else {
	                        _this.setState(_extends(state, { purchaseCompleted: true, license: resp.body }));
	                    }
	                }).catch(function (err) {
	                    _this.setState(_extends(state, {
	                        paymentProcessing: false, processingError: true, processingErrorMessage: 'Processing of request failed.  ' + err }));
	                });
	            });
	        };
	
	        _this.state = {
	            edition: getEdition(),
	            first_name: '',
	            last_name: '',
	            email: '',
	            phone: '',
	            company: '',
	            card_name: '',
	            quantity: 1,
	            processingError: false,
	            processingErrorMessage: '',
	            contactError: false,
	            contactErrorMessage: '',
	            paymentError: false,
	            paymentErrorMessage: '',
	            purchaseCompleted: false,
	            licenseKey: '',
	            activationKey: '',
	            paymentProcessing: false,
	            paymentDetailsComplete: false,
	            paymentDetailsMessage: ''
	        };
	        _this.handleOnChange = _this.handleOnChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleOnChangePaymentDetails = _this.handleOnChangePaymentDetails.bind(_this);
	        return _this;
	    }
	
	    CheckoutForm.prototype.handleOnChange = function handleOnChange(event) {
	        var _extends2;
	
	        this.setState(_extends(this.state, (_extends2 = {}, _extends2[event.target.name] = event.target.value, _extends2)));
	    };
	
	    CheckoutForm.prototype.handleOnChangePaymentDetails = function handleOnChangePaymentDetails(changeObj) {
	        this.setState(_extends(this.state, { paymentDetailsComplete: changeObj.complete, paymentDetailsMessage: changeObj.error ? changeObj.error.message : '' }));
	    };
	
	    CheckoutForm.prototype.render = function render() {
	        var state = this.state;
	        var props = this.props;
	
	        if (!serverHost || serverHost === '' || serverHost === 'undefined') {
	            return _react2.default.createElement(
	                'div',
	                null,
	                'serverHost environment var is not appropriately set'
	            );
	        }
	
	        if (state.purchaseCompleted === true) {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Realfire Purchase Completed'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Thank you for purchasing Realfire. We appreciate your business.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Here are the license details. You can activate Realfire using License/Activation Keys. If you need help activating, please see the ',
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/products/realfire/docs#activation' },
	                        'help page'
	                    ),
	                    '.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Please do not share the license details with unauthorized parties.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Email has been sent to ',
	                    _react2.default.createElement(
	                        'code',
	                        null,
	                        state.email
	                    ),
	                    ' with same details. If you have any questions, please contact us at ',
	                    _react2.default.createElement(
	                        'a',
	                        { href: "mailto:support@datasert.com?subject=About License " + state.licenseKey },
	                        'support@datasert.com'
	                    ),
	                    '.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'license-details' },
	                    _react2.default.createElement(
	                        'table',
	                        null,
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    { nowrap: true },
	                                    'Product'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    state.license.product
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    { nowrap: true },
	                                    'Quantity'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    state.license.quantity
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    { nowrap: true },
	                                    'Purchased on'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    state.license.purchased_on
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    { nowrap: true },
	                                    'Renews on'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    state.license.renews_on
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    { nowrap: true },
	                                    'License Key'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    state.license.license_key
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    { nowrap: true },
	                                    'Activation Key'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    state.license.activation_key
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	
	        var options = [];
	        for (var i = 1; i <= 100; i++) {
	            options.push(_react2.default.createElement(
	                'option',
	                { value: i },
	                i
	            ));
	        }
	
	        return _react2.default.createElement(
	            'form',
	            { method: 'POST', onSubmit: this.handleSubmit },
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Buy Realfire'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Please provide product, contact, payment details and place order.  After successful purchase, License/Activation Keys will be displayed and also will be sent in an email.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'If you have any questions, we will be glad to clarify them. Please reach us at ',
	                _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:support@datasert.com' },
	                    'support@datasert.com'
	                )
	            ),
	            _react2.default.createElement(
	                'h5',
	                null,
	                'PO Purchase'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'If you need to purchase via PO, please see the details ',
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/products/realfire/buypo' },
	                    'here'
	                ),
	                '.'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'payment-section product-details' },
	                state.processingError && _react2.default.createElement(
	                    'div',
	                    { className: 'error-message' },
	                    state.processingErrorMessage
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Product Details'
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Input,
	                    { type: 'select', name: 'edition', id: 'edition', onChange: this.handleOnChange, value: state.edition },
	                    _react2.default.createElement(
	                        'option',
	                        { value: 'essential' },
	                        'Realfire Essential'
	                    ),
	                    _react2.default.createElement(
	                        'option',
	                        { value: 'professional' },
	                        'Realfire Professional'
	                    ),
	                    _react2.default.createElement(
	                        'option',
	                        { value: 'enterprise' },
	                        'Realfire Enterprise'
	                    )
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'quantity' },
	                    'Seats'
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Input,
	                    { type: 'select', name: 'quantity', id: 'quantity', onChange: this.handleOnChange, value: state.quantity },
	                    options
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'unit-price' },
	                    ' x '
	                ),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    '$',
	                    getUnitPrice(state.edition, state.quantity)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    { className: 'total-price-line' },
	                    'Total: ',
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'total-price' },
	                        '$',
	                        getTotalPrice(state.edition, state.quantity)
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'per-unit' },
	                        'per year'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'payment-section license-contact' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Contact Details'
	                ),
	                state.contactError && _react2.default.createElement(
	                    'div',
	                    { className: 'error-message' },
	                    state.contactErrorMessage
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactstrap.Col,
	                        null,
	                        _react2.default.createElement(_reactstrap.Input, { className: 'field-required', type: 'text', name: 'first_name', id: 'first_name', placeholder: 'First Name', onChange: this.handleOnChange, value: state.first_name })
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Col,
	                        null,
	                        _react2.default.createElement(_reactstrap.Input, { className: 'field-required', type: 'text', name: 'last_name', id: 'last_name', placeholder: 'Last Name', onChange: this.handleOnChange, value: state.last_name })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactstrap.Col,
	                        null,
	                        _react2.default.createElement(_reactstrap.Input, { className: 'field-required', type: 'email', name: 'email', id: 'email', placeholder: 'Email (license will be sent to this email)', onChange: this.handleOnChange, value: state.email })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactstrap.Col,
	                        null,
	                        _react2.default.createElement(_reactstrap.Input, { className: 'field-required', type: 'phone', name: 'phone', id: 'phone', placeholder: 'Phone', onChange: this.handleOnChange, value: state.phone })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactstrap.Col,
	                        null,
	                        _react2.default.createElement(_reactstrap.Input, { type: 'text', name: 'company', id: 'company', placeholder: 'Company', onChange: this.handleOnChange, value: state.company })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'payment-section card-details' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Payment Details'
	                ),
	                state.paymentError && _react2.default.createElement(
	                    'div',
	                    { className: 'error-message' },
	                    state.paymentErrorMessage
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Row,
	                    { className: 'card-name' },
	                    _react2.default.createElement(
	                        _reactstrap.Col,
	                        null,
	                        _react2.default.createElement(_reactstrap.Input, { className: 'field-required', type: 'text', name: 'card_name', id: 'card_nanme', placeholder: 'Card Holder\'s name', onChange: this.handleOnChange, value: state.name })
	                    )
	                ),
	                _react2.default.createElement(_reactStripeElements.CardElement, { style: {
	                        base: {
	                            fontSize: '18px', color: '#495057', '::placeholder': {
	                                color: '#aaa',
	                                fontWeight: 'normal'
	                            } }
	                    }, onChange: this.handleOnChangePaymentDetails })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'payment-section' },
	                'By placing order, you are agreeing to Realfire ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '/resources/eula', target: '_blank' },
	                    'EULA'
	                ),
	                ' and ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '/resources/privacy', target: '_blank' },
	                    'Privacy Policy'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'payment-section' },
	                _react2.default.createElement(
	                    _reactstrap.Button,
	                    { disabled: state.paymentProcessing, color: 'primary' },
	                    state.paymentProcessing ? "Processing..." : "Place Order"
	                )
	            ),
	            state.paymentProcessing && _react2.default.createElement(
	                'div',
	                { className: 'backdrop' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'backdrop-content' },
	                    _react2.default.createElement(_spinner2.default, null),
	                    ' Processing Request. Please wait...'
	                )
	            )
	        );
	    };
	
	    return CheckoutForm;
	}(_react2.default.Component);
	
	exports.default = (0, _reactStripeElements.injectStripe)(CheckoutForm);
	module.exports = exports['default'];

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Spinner = function Spinner() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'spinner loading' },
	        _react2.default.createElement('div', { className: 'loading-bar' }),
	        _react2.default.createElement('div', { className: 'loading-bar' }),
	        _react2.default.createElement('div', { className: 'loading-bar' }),
	        _react2.default.createElement('div', { className: 'loading-bar' })
	    );
	};
	
	exports.default = Spinner;
	module.exports = exports['default'];

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactStripeElements = __webpack_require__(38);
	
	__webpack_require__(754);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var windowDefined = typeof window !== 'undefined';
	var stripePublicKey = '' + ("pk_live_Cy86180G02x5yjXW54QW3Q9K");
	
	var BuyPage = function (_Component) {
	    _inherits(BuyPage, _Component);
	
	    function BuyPage() {
	        _classCallCheck(this, BuyPage);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    BuyPage.prototype.render = function render() {
	        if (!windowDefined) {
	            return _react2.default.createElement('div', null);
	        } else {
	            if (!stripePublicKey || stripePublicKey === '' || stripePublicKey === 'undefined') {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    'Stripe Public key is not specified'
	                );
	            }
	
	            var Checkout = __webpack_require__(393);
	            return _react2.default.createElement(
	                _reactStripeElements.StripeProvider,
	                { apiKey: stripePublicKey },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'buy-container' },
	                    _react2.default.createElement(_reactHelmet2.default, { title: 'Datasert - Buy Realfire' }),
	                    _react2.default.createElement(Checkout, null)
	                )
	            );
	        }
	    };
	
	    return BuyPage;
	}(_react.Component);
	
	exports.default = BuyPage;
	module.exports = exports['default'];

/***/ }),

/***/ 754:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-products-realfire-buy-jsx-1a0398ac1361f8fb510a.js